import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'service-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class ServiceCounterComponent implements OnInit, OnDestroy {

  subscribion: Subscription;
  counter: Array<any>;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.subscribion = this.translate.stream('COUNTER').subscribe((res) => {
      this.counter = Array<any>();
      this.counter.push(res['days']);
      this.counter.push(res['experience']);
      this.counter.push(res['coffee cup']);
      this.counter.push(res['industries']);
    });
  }
  ngOnDestroy(): void {
    this.subscribion.unsubscribe();
  }
}
